module.exports = __webpack_public_path__ + "img/book-white.7e4ef5cd.svg";